import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import BulkUploadForm, {
  TemplateHelperText,
} from "../../../../forms/BulkUploadForm";
import CheckboxWithError from "../../../../inputs/CheckboxWithError";

export { Anchor } from "../../../../forms/BulkUploadForm";

export const Checkbox = styled(CheckboxWithError)`
  padding: 16px 0px 16px 0px;
`;

const TEMPLATE_ROWS = [
  "code,description,is_archived",
  "C1,This GLCode is active,0",
  "C2,This GLCode is archived,1",
  "C3,This is another archived GLCode,1",
];

export const HelperText = () => (
  <TemplateHelperText
    rows={TEMPLATE_ROWS}
    fileName="Bulk GLCode Template.csv"
    linkText="Download GL Codes Template"
  />
);

const ImportFromFile = ({
  onSubmit,
  setFieldValue,
  loading,
  pluralEntity,
  file,
}) => {
  const [ignoreDuplicates, setIgnoreDuplicates] = useState(true);

  useEffect(() => {
    setFieldValue("ignoreDuplicates", ignoreDuplicates);
  }, [ignoreDuplicates, setFieldValue]);

  return (
    <BulkUploadForm
      onSubmit={onSubmit}
      loading={loading}
      pluralEntity={pluralEntity}
      file={file}
      helperText={<HelperText />}
    >
      <Checkbox
        label={"Ignore Duplicates"}
        value={ignoreDuplicates}
        onChange={() =>
          loading ? null : setIgnoreDuplicates(!ignoreDuplicates)
        }
      />
    </BulkUploadForm>
  );
};

ImportFromFile.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  pluralEntity: PropTypes.string.isRequired,
  file: PropTypes.shape({}),
  loading: PropTypes.bool,
};

export default ImportFromFile;
